import {
  SEND_TEST_DAILY_MAIL_REQUEST,
  SEND_TEST_DAILY_MAIL_SUCCESS,
  SEND_TEST_DAILY_MAIL_FAIL,
} from "../constants/generalConstant";

import history from "../config/history";
import { errorHandler } from "./errorHandler";
import { localAPI } from "../api/local";

export const sendDailyMailTest = () => async (dispatch) => {
  try {
    dispatch({
      type: SEND_TEST_DAILY_MAIL_REQUEST,
    });
    await localAPI.get("/api/videos/sendDailyMailTest");
    dispatch({
      type: SEND_TEST_DAILY_MAIL_SUCCESS,
    });

    history.go(0);
  } catch (error) {
    errorHandler(
      SEND_TEST_DAILY_MAIL_FAIL,
      error,
      false,
      dispatch,
      (type, errMessage) => {
        console.log(errMessage);
      }
    );
  }
};
